// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__XIM9b","disclaimerContainer":"styles_disclaimerContainer__ypGa1","link":"styles_link__aartU","willBeReplaced":"styles_willBeReplaced__lbNiu"};